export enum definitionOfDoneDisplayType {
  popup = 'popup',
  issueCard = 'issueCard'
}
